import React from "react";
import { Paper, Typography, Box, IconButton, useTheme } from "@mui/material";
import {
  Instagram as InstagramIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";
import { UserProfile } from "../../types";

interface SocialLinksCardProps {
  userData: UserProfile;
}

const SocialLinksCard: React.FC<SocialLinksCardProps> = ({ userData }) => {
  const theme = useTheme();

  return (
    <Paper elevation={0} sx={{ p: 3, textAlign: "center" }}>
      <Typography
        variant="h5"
        sx={{
          color: theme.palette.materiom.seaweed,
          fontWeight: 600,
          mb: 2,
        }}
      >
        Connect
      </Typography>
      {(userData.instagram || userData.twitter || userData.linkedIn) && (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          {userData.instagram && (
            <IconButton
              component="a"
              href={userData.instagram}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: theme.palette.materiom.seaweed,
                "&:hover": { transform: "scale(1.1)" },
              }}
            >
              <InstagramIcon />
            </IconButton>
          )}
          {userData.twitter && (
            <IconButton
              component="a"
              href={userData.twitter}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: theme.palette.materiom.seaweed,
                "&:hover": { transform: "scale(1.1)" },
              }}
            >
              <TwitterIcon />
            </IconButton>
          )}
          {userData.linkedIn && (
            <IconButton
              component="a"
              href={userData.linkedIn}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: theme.palette.materiom.seaweed,
                "&:hover": { transform: "scale(1.1)" },
              }}
            >
              <LinkedInIcon />
            </IconButton>
          )}
        </Box>
      )}
    </Paper>
  );
};

export default SocialLinksCard;
